import { MainSections, ContentWrapper } from "../../Components/index";

export default function Plans() {
    return (
        <div>
            <MainSections>
                <ContentWrapper title="Plans">
                    <h1>Zana</h1>
                </ContentWrapper>
            </MainSections>
        </div>
    )
}
